document.addEventListener("DOMContentLoaded", function () {
    const addToCartButton = document.querySelector('[data-add-to-cart-trigger]');
    const form = document.querySelector('.buy-buttons__form-scroll');
    if (addToCartButton && window.innerWidth < 720) {
        if (document.querySelector('.buy-buttons__form-scroll')) {
            document.addEventListener('scroll', function () {
                const elementYPosition = form.getBoundingClientRect().y;
                const elementHeight = form.getBoundingClientRect().height
                const viewportTop = document.querySelector('[data-header]').getBoundingClientRect().height - elementHeight;
                const viewportHeight = window.innerHeight;

                if (elementYPosition > viewportTop && elementYPosition < viewportHeight) {
                    if (addToCartButton && addToCartButton.classList.contains('buy-buttons__cart-submit-fixed')) {
                        addToCartButton.classList.remove('buy-buttons__cart-submit-fixed');
                    }
                } else {
                    if (addToCartButton && !addToCartButton.classList.contains('buy-buttons__cart-submit-fixed')) {
                        addToCartButton.classList.add('buy-buttons__cart-submit-fixed');
                    }
                }
            })
        }
    }
})
